import request from '@/utils/request'
import Qs from 'qs'
export async function smsCode(params) {
  return request({
    url: '/user/smsCode',
    method: 'post',
    params,
  })
}
/**
 * @description 账号密码登录
 * @param {String}  
 * @returns {loginType,pass,phone}
 */
export function loginByLogin(data) {
  return request({
    url: '/user/loginByLoginType',
    method: 'post',
    data,
  })
}
export function loginh5(data) {
  return request({
    url: '/open/h5/login',
    method: 'post',
    data,
  })
}

export function smsanyone(params) {
  return request({
    url: '/open/public/sms/anyone',
    method: 'get',
    params,
  })
}
export function registerDo(data) {
  return request({
    url: '/open/h5/registerDo',
    method: 'post',
    data,
  })
}
/**
 * @description 邀请用户
 * @param {String}  
 * @returns {loginType,pass,phone}
 */
export function inviteUser(data) {
  return request({
    url: '/open/h5/invite/register',
    method: 'post',
    data,
  })
}




/**
 * @description 退出登录
 * @param {String}  
 * @returns {loginType,pass,phone}
 */

/**
 * @description 获取用户信息
 * @param {String}  
 * @returns {loginType,pass,phone}
 */

export function getdata(params) {
  return request({
    url: '/open/content/homePage',
    method: 'get',
    params,
  })
}
export function getAdvisorList(params) {
  return request({
    url: '/advisor/getAdvisorList',
    method: 'get',
    params,
  })
}
/**
 * @description 获取图形验证码
 * @param {String}  
 * @returns {loginType,pass,phone}
 */
export function captcha(params) {
  return request({
    url: '/user/captcha',
    method: 'post',
    params,
    hideLoading: true,
    // type:1
  })
}
export function findPassword(data) {
  return request({
    url: '/user/findPassword',
    method: 'post',
    data,
  })
}


export function resetPassword(data) {
  return request({
    url: '/open/public/resetPassword',
    method: 'post',
    data,
  })
}


export function onlineduration(data) {
  return request({
    url: '/user/my/app/online/duration',
    method: 'post',
    data
  })
}

export function starlist(data) {
  return request({
    url: '/social/star/list',
    method: 'get',
    data
  })
}